export default "__VITE_ASSET__BEAWojYx__"